import { isNullish } from '@epicuro-next/utilities';
import { createSelector } from '@ngrx/store';

import { ProductVariant } from '../models';

import { selectBackgroundProducts } from './business/config-strip-business.selectors';
import { selectConfigStripState } from './config-strip.feature.selector';

export const selectCurrentProductVariantsMap = createSelector(
  selectConfigStripState,
  (state) => {
    const variants = Object.values(state.data.variants) ?? [];
    const mappedVariants = variants.map<[string, string]>(
      ({ productId, brandId }: ProductVariant) => [productId, brandId],
    );

    return new Map(mappedVariants);
  },
);

export const selectCurrentBackgroundProductIndex = createSelector(
  selectCurrentProductVariantsMap,
  selectBackgroundProducts,
  (currentProductVariantsMap, backgroundProducts) =>
    backgroundProducts.findIndex(
      ({ productId, brandId }) =>
        currentProductVariantsMap.has(productId) &&
        brandId === currentProductVariantsMap.get(productId),
    ),
);

export const selectNextBackgroundProduct = createSelector(
  selectCurrentBackgroundProductIndex,
  selectBackgroundProducts,
  (currentBackgroundProductIndex, backgroundProducts) => {
    const nextBackgroundProduct =
      backgroundProducts[currentBackgroundProductIndex + 1];

    return currentBackgroundProductIndex === -1 ||
      isNullish(nextBackgroundProduct)
      ? null
      : backgroundProducts[currentBackgroundProductIndex + 1];
  },
);
